export default __webpack_public_path__ + "static/media/c2.4f48c63a.png";